module.exports = __webpack_public_path__ + "img/logo.0cd145a3.png";